
/**
 * Um das Plugin zu verwenden muss im jeweiligen EntryPoint wie folgt 
 * eingebunden werden:
 * 
 *      import Vue from "vue"
 *      import ModalPlugin from "./modal-plugin"
 *      Vue.use(ModalPlugin)
 * 
 * In der Anwendung können verschiedene ModalPanes (also Bereiche, die 
 * von einem Modal verdeckt werden) platziert werden:
 * 
 *      <modal-pane/> <!-- default pane-name ist "app" -->
 * 
 *      <modal-pane pane-name="myName"/>
 * 
 * Ein Modal kann aus jeder Vue Komponente heraus gestartet werden. Über
 * die Übergebenen Optionen können Daten an den Modal übergeben und
 * die Ziel-ModalPane kann anhand des Namens angegeben werden. Die Komponente,
 * die den Modal rendert muss übergeben werden und wird vom Plugin auf die 
 * jeweilige ModalPane gemounted.
 * 
 *   import MyModal from "./my-modal.vue"; 
 *   ...
 *   async onMyButtonClicked(){
 *      await result = this.$showMcModal({
 *          modalComponent: MyModal, 
 *          paneName: "",           // (optional) Name der ModalPane, default: "app"
 *          modalArgs: {...},       // (optional) Daten die im Modal verfügbar sein sollen, default: null
 *          allowEscape: true       // (optional) Wird der Modal beim Klicken des Randbereichs geschlossen?, default: true
 *      });
 *      let {
 *          wasEscaped,             // wurde der Modal durch Klicken des Randbereichs verlassen?
 *          returnValue             // Rückgabe vom Modal, ggf. null
 *      } = result;
 *   }
 * 
 * 
 * Bei der Modal Komponente (modalComponent) gibt es nur wenig zu beachten:
 * -    modalArgs steht als prop zur Verfügung, sodass man im Modal Zugriff auf
 *      notwendige Daten hat.
 * -    Der Dialog kann mit this.$emit("close",returnValue) verlassen werden, returnValue ist 
 *      Property der Rückgabe beim Auflösen des Promise.
 * 
 */

import Vue from "vue";
import Logger from "../logger";

const LOGGER = new Logger(__filename);

export const MODAL_BUS = new Vue();

import ModalPane from "./modal-pane.vue";

async function showMcModal(args = {}) {
    LOGGER.log("showMcModal", args);
    args.paneName = args.paneName || "app";
    args.allowEscape = args.allowEscape === false ? false : true;
    args.modalComponent = args.modalComponent || null;
    args.modalArgs = args.modalArgs || {};

    let resolve = null;
    let reject = null;
    let promise = new Promise((res, rej) => {
        resolve = res;
        reject = rej;
    });

    MODAL_BUS.$emit("show-modal", { ...args, resolve, reject });
    return promise;
}


export default ({
    install(VueConstructor) {
        // register the <modal-pane> component
        VueConstructor.component(ModalPane.name, ModalPane);
        // register the global $showMcModal Method
        VueConstructor.prototype.$showMcModal = showMcModal;
    }
});